import { useToggle } from "../../../../hooks/useToggle";

export const useModeEditorToggle = () => {
  const [advancedMode, toggleMode] = useToggle();

  return { advancedMode, toggleMode };
};
